var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.5,
    height: 21.5,
    viewBox: "0 0 21.5 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M-1539.78,21.281l-2-2a.75.75,0,0,1,0-1.061.75.75,0,0,1,1.06,0l2,2a.75.75,0,0,1,0,1.061.746.746,0,0,1-.53.22A.747.747,0,0,1-1539.78,21.281ZM-1557,17.5a10.183,10.183,0,0,1-3-7.249A10.186,10.186,0,0,1-1557,3a10.185,10.185,0,0,1,7.25-3,.75.75,0,0,1,.75.75.75.75,0,0,1-.75.751,8.69,8.69,0,0,0-6.188,2.561,8.691,8.691,0,0,0-2.562,6.188,8.691,8.691,0,0,0,2.562,6.188A8.694,8.694,0,0,0-1549.75,19a8.7,8.7,0,0,0,6.188-2.561A8.694,8.694,0,0,0-1541,10.25a.75.75,0,0,1,.75-.75.75.75,0,0,1,.75.75,10.182,10.182,0,0,1-3,7.249,10.181,10.181,0,0,1-7.249,3A10.182,10.182,0,0,1-1557,17.5Zm9.749-10a.75.75,0,0,1-.75-.75.75.75,0,0,1,.75-.75h3a.75.75,0,0,1,.75.75.75.75,0,0,1-.75.75Zm0-3a.75.75,0,0,1-.75-.75.75.75,0,0,1,.75-.751h6a.75.75,0,0,1,.75.751.75.75,0,0,1-.75.75Z",
    transform: "translate(1560)",
    fill: "gray"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.450b9e16c17a036c8c3b6f7cfa0ae384.svg";
export { ForwardRef as ReactComponent };